export * from './useCompactCompanyPaymentsSecondaryMenu.types';
export { default as useCompactCompanyPaymentsSecondaryMenu } from './useCompactCompanyPaymentsSecondaryMenu';
